import { useTrackingActionMutation } from '../../hooks/use-tracking-action-mutation';
export function ActionMutationProvider(_ref) {
  var children = _ref.children;
  var mutation = useTrackingActionMutation();
  return children(mutation);
}